import { useEffect } from 'react';
import { isIOS } from './pwaInstall';

/**
 * iOS zooms the page in when a field is tapped and leaves it zoomed, carrying
 * the right side of the form off screen. It does this whenever the field's
 * on-screen text is under 16px, so a 16px input isn't enough once Safari's own
 * page zoom (aA) has shrunk the site. Capping the scale stops it; held to the
 * auth pages because an installed app can lose pinch zoom under this cap.
 */
export default function useNoFocusZoomOnIOS() {
  useEffect(() => {
    const viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport || !isIOS()) return undefined;
    const original = viewport.getAttribute('content');
    viewport.setAttribute('content', `${original}, maximum-scale=1`);
    return () => viewport.setAttribute('content', original);
  }, []);
}
